import { AI_CREDIT_REQUEST_ENDPOINT } from "../config/api-endpoints"
import { authorizeHeader } from "../utils/auth-header"

export const getFreeAICreditAPICall = async () => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    }

    const response = await window.fetch(AI_CREDIT_REQUEST_ENDPOINT + "free-credits", authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }
  } catch (e) {
    console.error('ERROR: ', e)
    return e
  }
}